<template>
  <div class="huanjing" style="padding-top: 50px;">
    <img src="../../static/image/huanjing_title.png" class="fullWidth" />

    <Row type="flex" justify="center" class="code-row-bg">
      <Col span="16">
        <div>
          <div style="height: 50px;"></div>
          <table class="centerLR">
            <tr>
              <td width="120" v-for="(item,index) in titleList" :key="index">
                <div
                  style="width: 100px;height: 40px;line-height: 40px;border:1px solid #fd7b35;text-align:center"
                  class="centerLR font12 fontfaYahei curP"
                  @click="clickTitle(index,item)"
                  :class="[index==titleIndex?'titStyle':'']"
                >{{item.brand_name}}</div>
              </td>
            </tr>
          </table>
          <div style="height: 50px;"></div>
          <div>
            <el-carousel :interval="4000" autoplay='false' type="card" height="450px">
              <el-carousel-item v-for="(item,index) in gongsiList" :key="index">
                <img :src="item.photo_url" class="imgCard" />
                <p class="word">{{item.photo_description}}</p>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </Col>
    </Row>
    <xfck></xfck>
  </div>
</template>

<script>
import $ from "jquery";
import xfck from "./xfck.vue";
import Swiper from "swiper";
require("../assets/css/swipers.css");
var img_url_i = "";
export default {
  name: "huanjing",
  data() {
    return {
      titleIndex: 0,
      titleList: [
        { name: "公司环境", isYes: true, isNo: false, value: "1" },
        { name: "办公室", isYes: false, isNo: true, value: "2" },
        { name: "园区环境", isYes: false, isNo: true, value: "3" },
        { name: "办公室", isYes: false, isNo: true, value: "4" }
      ],
      gongsiList: [
        {
          photo_description: "非常难得又值钱的认证证书1",
          photo_url: img_url_i + "/static/image/huanjing_img2.png"
        },
        {
          photo_description: "非常难得又值钱的认证证书1",
          photo_url: img_url_i + "/static/image/huanjing_img2.png"
        },
        {
          photo_description: "非常难得又值钱的认证证书1",
          photo_url: img_url_i + "/static/image/huanjing_img2.png"
        }
      ],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      var that = this;
      var url =that.baseUrl + "/jianyun/api/mall.php?c=photo/getPhotoBrandList";
      that.axios.get(url, {
          params: {}
        }).then(res => {
          if (res.data.success) {
            that.titleList = res.data.data.list;
            this.getHuanjing(that.titleList[0].id);
          } else {
            this.$Message.warning(res.data.msg);
          }
        }).catch(error => {
          console.log(error);
        });
    },
    clickTitle(index, item) {
      var that = this;
      that.titleIndex = index;
      that.getHuanjing(item.id)
    },
    // 获取图片
    getHuanjing(id){
      var that=this;
      that.gongsiList=[]
      var url=that.baseUrl+"/jianyun/api/mall.php?c=photo/getPhotosList"
      that
        .axios(url, {
          params: {brand_id:id}
        })
        .then(res => {
          if (res.data.success) {
            for(var i=0;i<res.data.data.list.length;i++){
              res.data.data.list[i].photo_url=that.img_url+res.data.data.list[i].photo_url;
            }
            that.gongsiList=res.data.data.list
          } else {
            this.$Message.warning(res.data.msg);
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  components: {
    xfck
  }
};
</script>
<style>
  .imgCard{
    width:100%;
    height: 400px;
  }
  .el-carousel__indicators{
    margin: 20px 0 ;
  }
  .el-carousel__button{
    width: 10px;
    height: 10px;
    background-color: #fff;
    border-radius: 50%;
    border: 2px solid #fd7b35;
  }
  .el-carousel__arrow{
    /* display: block!important; */
    width: 45px;
    height: 45px;
    background-color: #fd7b35;
  }
  .el-carousel__indicators--outside button{
    background-color: #fff;
  }
  .el-carousel__arrow:hover{
    color: #fff; 
    background-color: #fd7b35; 
    border: 2px solid #fd7b35;
  }
  .word{
    position: absolute;
    color: #000;
    bottom: 0px;
    left: 50%;
    transform: translate(-50%);
   
  }
.titStyle {
  width: 90px !important;
  text-align: center;
  background-color: #fd7b35;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/huanjing.vue